<template>
    <div class="sidebar-box">
        <ul>
            <!-- 充值 -->
            <li>
                <router-link class="col-center" :to="rechargeConfig.path">
                    <i class="iconfont sidebar-icon" :class="rechargeConfig.icon"></i>
                    <span class="sidebar-text">{{ rechargeConfig.text }}</span>
                </router-link>
            </li>

            <!-- 官方客服 -->
            <li class="more">
                <a class="col-center" href="javascript:;">
                    <i class="iconfont sidebar-icon" :class="serviceConfig.triggerIcon"></i>
                    <span class="sidebar-text">{{ serviceConfig.text }}</span>
                </a>
                <div class="customer-service service-popup">
                    <div class="customer-service-box">
                        <p class="popup-title">{{ serviceConfig.popupTitle }}</p>
                        <!-- 在线客服 -->
                        <p class="service-item">
                            <span class="item-label"><i class="iconfont" :class="serviceConfig.online.icon"></i>{{
                                serviceConfig.online.label }}</span>
                            <a class="cgmodel-btn service-btn" role="button" :href="serviceConfig.online.link"
                                target="_blank">{{ serviceConfig.online.btnText }}</a>
                        </p>
                        <!-- 帮助中心 -->
                        <p class="service-item">
                            <span class="item-label"><i class="iconfont" :class="serviceConfig.help.icon"></i>{{
                                serviceConfig.help.label }}</span>
                            <router-link class="cgmodel-btn service-btn" role="button" :to="serviceConfig.help.path">{{
                                serviceConfig.help.btnText }}</router-link>
                        </p>
                        <!-- 电话 -->
                        <p class="service-item phone-item">
                            <i class="iconfont" :class="serviceConfig.phone.icon"></i>{{ serviceConfig.phone.label }} {{
                            serviceConfig.phone.number }}
                        </p>
                        <!-- 工作时间 -->
                        <div class="work-time">
                            <span v-for="(time, index) in serviceConfig.workTime" :key="index">{{ time }}</span>
                        </div>

                        <!-- 业务操作列表 -->
                        <div v-for="(item, index) in serviceConfig.operations" :key="index" class="service-operation"
                            :class="{ 'first-operation': index === 0 }">
                            <span class="item-label"><i class="iconfont" :class="item.icon"></i>{{ item.label }}</span>

                            <!-- 链接类型区分 -->
                            <router-link v-if="item.type === 'router'" class="cgmodel-btn service-btn" role="button"
                                :to="item.path">
                                {{ item.btnText }}
                            </router-link>
                            <a v-else class="cgmodel-btn service-btn" role="button" :href="item.link || 'javascript:;'"
                                :target="item.link ? '_blank' : ''">
                                {{ item.btnText }}
                            </a>

                            <!-- 扫码弹窗 -->
                            <div v-if="item.scan" class="scan-box">
                                <p class="scan-title"><i class="iconfont" :class="item.scan.icon"></i>{{ item.scan.title
                                    }}</p>
                                <img class="scan-img" :src="item.scan.img">
                                <p class="scan-desc">{{ item.scan.desc }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>

            <!-- 官方群 -->
            <li class="more">
                <a class="col-center" href="javascript:;">
                    <i class="iconfont sidebar-icon" :class="groupConfig.triggerIcon"></i>
                    <span class="sidebar-text">{{ groupConfig.text }}</span>
                </a>
                <div class="customer-service group-popup">
                    <div class="customer-service-box group-box">
                        <!-- 微信群 -->
                        <div class="wechat-group">
                            <p class="group-title"><i class="iconfont group-icon"
                                    :class="groupConfig.wechat.icon"></i>{{ groupConfig.wechat.title }}</p>
                            <div class="group-list">
                                <div class="group-col" v-for="(col, colIndex) in groupConfig.wechat.columns"
                                    :key="colIndex">
                                    <p v-for="(group, gIndex) in col" :key="gIndex" class="group-item">
                                        <span class="group-label">{{ group.no }}</span>{{ group.name }}
                                    </p>
                                </div>
                            </div>
                            <div class="scan-area">
                                <img :src="groupConfig.wechat.scan.img">
                                <div class="scan-info">
                                    <p>{{ groupConfig.wechat.scan.title }}</p>
                                    <p class="scan-tip">{{ groupConfig.wechat.scan.tip }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- QQ群 -->
                        <div class="qq-group">
                            <p class="group-title"><i class="iconfont group-icon" :class="groupConfig.qq.icon"></i>{{
                                groupConfig.qq.title }}</p>
                            <a class="cgmodel-btn qq-btn" role="button" :href="groupConfig.qq.link" target="_blank"
                                rel="nofollow">{{ groupConfig.qq.number }}</a>
                            <p class="qq-tip">{{ groupConfig.qq.tip }}</p>
                        </div>
                    </div>
                </div>
            </li>

            <!-- 意见反馈 -->
            <li>
                <router-link class="col-center" :to="feedbackConfig.path">
                    <i class="sidebar-icon" :class="feedbackConfig.icon"></i>
                    <span class="sidebar-text">{{ feedbackConfig.text }}</span>
                </router-link>
            </li>

            <!-- 回顶部 -->
            <li class="sidebar-upper" id="returnTop" :class="{ 'show': showBackToTop }" @click="scrollToTop">
                <a class="col-center" href="javascript:;">
                    <i class="sidebar-icon" :class="backToTopConfig.icon"></i>
                    <span class="sidebar-text">{{ backToTopConfig.text }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'SideBar',
    data() {
        return {
            showBackToTop: false,
            scrollThreshold: 300,

            // 充值配置
            rechargeConfig: {
                text: '充值',
                icon: 'icon-box_chongzhi',
                path: '/'
            },

            // 客服配置
            serviceConfig: {
                text: '官方客服',
                triggerIcon: 'icon-box_lianxikefu',
                popupTitle: '联系客服',
                online: {
                    label: '在线客服：',
                    icon: 'icon-kefu1',
                    btnText: '立即咨询',
                    // link: 'https://wpa1.qq.com/7Sfp1jVj?_type=wpa&qidian=true'
                },
                help: {
                    label: '寻求帮助：',
                    icon: 'icon-wenhaofill',
                    btnText: '帮助中心',
                    path: '/help'
                },
                phone: {
                    label: '联系电话：',
                    icon: 'icon-dianhua',
                    number: '13705655393'
                },
                workTime: [
                    '工作时间：周一至周五9:00-12:00',
                    '14:00-18:00'
                ],
                operations: [
                    {
                        label: '商务合作：',
                        icon: 'icon-zhaopin',
                        btnText: '申请合作',
                        scan: {
                            title: '商务合作',
                            icon: 'icon-zhaopin',
                            img: require('@/assets/images/customer-weibo-service.png'),
                            // img: 'https://static.cgmodel.com/img/customer-wechat-service231114.png',
                            desc: '扫码添加微信客服'
                        }
                    },
                    {
                        label: '模型定做：',
                        icon: 'icon-a-ziyuan523',
                        btnText: '提交需求',
                        scan: {
                            title: '模型定做',
                            icon: 'icon-a-ziyuan523',
                            img: require('@/assets/images/customer-weibo-service.png'),
                            // img: 'https://static.cgmodel.com/img/customer-wechat-service231114.png',
                            desc: '扫码添加微信客服'
                        }
                    },
                    {
                        label: '微信客服：',
                        icon: 'icon-weixin',
                        btnText: '加微信聊',
                        scan: {
                            title: '模型定做',
                            icon: 'icon-weixin',
                            img: require('@/assets/images/customer-weibo-service.png'),
                            // img: 'https://static.cgmodel.com/img/customer-wechat-service231114.png',
                            desc: '扫码添加微信客服'
                        }
                    },
                    {
                        label: '发票开具：',
                        icon: 'icon-ticket-fill',
                        btnText: '申请开票',
                        type: 'router',
                        path: '/user-center/buyer/invoice'
                    }
                ]
            },

            // 官方群配置
            groupConfig: {
                text: '官方群',
                triggerIcon: 'icon-boxguanfangqun',
                wechat: {
                    title: '官方微信群',
                    icon: 'icon-weixin',
                    columns: [
                        [
                            { no: '01', name: '建筑动画交流群' },
                            { no: '02', name: '影视动画交流群' },
                            { no: '03', name: '游戏美术交流群' },
                            { no: '04', name: '潮玩手办交流群' }
                        ],
                        [
                            { no: '05', name: '游戏引擎交流群' },
                            { no: '06', name: 'C4D视觉交流群' },
                            { no: '07', name: '装机设备交流群' },
                            { no: '08', name: '综合交流群' }
                        ]
                    ],
                    scan: {
                        img: require('@/assets/images/customer-weibo-service.png'),
                        // img: 'https://static.cgmodel.com/img/customer-wechat-group-scan-yy.png',
                        title: '微信扫码添加管理员 徐工 加群',
                        tip: '严格审核打造高质量交流群'
                    }
                },
                qq: {
                    title: '官方QQ群',
                    icon: 'icon-qq1',
                    number: '2515696045',
                    // link: 'https://qm.qq.com/cgi-bin/qm/qr?k=eyPI-nvFpLgCFUEPoeI7yxwh1u8za0Jz&jump_from=webapi&authKey=SZ9EEXez9DYwhUK+vB/MHhmeM+LzjBqryo8ytAFjfnSVX+KAgEgn/CVgAgF2QawQ',
                    tip: '点击加群'
                }
            },

            // 意见反馈配置
            feedbackConfig: {
                text: '意见反馈',
                icon: 'ri-mail-line',
                path: '/feedback'
            },

            // 回顶部配置
            backToTopConfig: {
                text: '回顶部',
                icon: 'ri-arrow-up-s-line'
            }
        }
    },
    methods: {
        handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            this.showBackToTop = scrollTop > this.scrollThreshold
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style lang="scss" scoped>
.col-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.sidebar-box {
    position: fixed;
    top: 50%;
    right: 10px;
    z-index: 9998;
    margin-top: 54px;
    transform: translateY(-50%);

    .iconfont {
        width: auto;
        height: auto;
        margin-top: 0;
        line-height: 1;

        &.fz20 {
            font-size: 20px;
        }
    }

    ul {
        position: relative;
        margin: 0;
        padding: 0;
        list-style: none;

        &:before {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 54px;
            width: 100%;
            z-index: 0;
            background-color: rgba(107, 107, 107, 0.6);
            backdrop-filter: blur(8px);
            border-radius: 8px;
            content: "";
        }

        li {
            position: relative;
            width: 44px;
            box-sizing: border-box;
            z-index: 1;
            margin: 0;
            padding: 0;

            &.sidebar-upper {
                margin-top: 10px;
            }

            &:first-child,
            &:first-child>a {
                border-radius: 8px 8px 0 0;
            }

            &:nth-last-child(2),
            &:nth-last-child(2)>a {
                border-radius: 0 0 8px 8px;
            }

            &>a {
                width: 100%;
                min-height: 44px;
                padding: 6px 0;
                color: rgba(255, 255, 255, 0.8);
                transition: all 0.5s ease;
                text-decoration: none;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }

            &:hover>a {
                background-color: rgba(255, 255, 255, 0.15);
                color: #fff;
            }

            &:hover .customer-service {
                visibility: visible;
                opacity: 1;
            }

            &.more {
                &:before {
                    position: absolute;
                    top: 50%;
                    right: 46px;
                    width: 0;
                    height: 0;
                    margin-top: -12px;
                    border-top: 12px solid transparent;
                    border-bottom: 12px solid transparent;
                    border-left: 14px solid #404040;
                    content: "";
                    visibility: hidden;
                    opacity: 0;
                    transition: all 0.2s ease;
                    z-index: 1000;
                    pointer-events: none;
                }

                &:hover:before {
                    visibility: visible;
                    opacity: 1;
                }
            }

            &.sidebar-upper {
                opacity: 0;
                visibility: hidden;
                transition: opacity 0.5s ease, visibility 0.5s ease;
                background-color: rgba(107, 107, 107, 0.6);
                backdrop-filter: blur(8px);
                border-radius: 8px;

                &.show {
                    opacity: 1;
                    visibility: visible;
                }

                &>a {
                    padding: 0;
                    border-radius: 8px;

                    .iconfont {
                        margin-bottom: -3px;
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
            }
        }
    }

    .sidebar-icon {
        font-size: 18px;
        line-height: 20px;

        &.icon-boxguanfangqun {
            font-size: 20px;
        }

        &.icon-yijianfankui2 {
            font-size: 16px;
        }
    }

    .sidebar-text {
        font-size: 20px;
        line-height: 20px;
        transform: scale(0.5);
        transform-origin: center;
        white-space: nowrap;
    }
}

.customer-service {
    position: absolute;
    top: 50%;
    right: 43px;
    padding-right: 15px;
    visibility: hidden;
    opacity: 0;
    transform: translateY(-50%);
    transition: all 0.2s ease;
    z-index: 1001;

    &.service-popup .customer-service-box {
        width: 243px;
        padding: 20px;
    }

    &.group-popup .customer-service-box {
        display: flex;
    }
}

.customer-service-box {
    background-color: #404040;
    box-sizing: border-box;
    border-radius: 10px;
    color: #ddd;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    text-align: left;

    .popup-title {
        color: #fff;
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 15px;
    }

    .service-item {
        display: flex;
        align-items: center;
        margin-top: 15px;

        &:first-of-type {
            margin-top: 0;
        }

        &.phone-item {
            line-height: 20px;

            .iconfont {
                margin-right: 8px;
            }
        }

        .item-label {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            white-space: nowrap;

            .iconfont {
                margin-right: 8px;
            }
        }
    }

    .service-btn {
        width: 103px;
        height: 32px;
        margin-left: 5px;
        background-color: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        color: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        text-decoration: none;
        font-size: 12px;

        &:hover {
            background-color: #409EFF; // 主题蓝色
            border-color: #409EFF; // 主题蓝色
            color: #fff;
        }
    }

    .work-time {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        color: #999;
        border-bottom: 1px solid #505050;
        padding-bottom: 20px;
        margin-top: 15px;
        font-size: 12px;
        line-height: 16px;
    }

    .service-operation {
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        margin-top: 10px;

        &.first-operation {
            margin-top: 20px;
        }

        .item-label {
            display: flex;
            align-items: center;
            font-weight: lighter;
            flex-shrink: 0;
            white-space: nowrap;

            .iconfont {
                margin-right: 8px;
            }
        }

        &:hover .scan-box {
            display: flex;
        }
    }

    .scan-box {
        position: absolute;
        left: -170px;
        bottom: 0;
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 156px;
        height: 182px;
        background-color: #404040;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        z-index: 1002;

        .scan-title {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            line-height: 20px;

            .iconfont {
                margin-right: 5px;
            }
        }

        .scan-img {
            width: 100px;
            height: 100px;
            border-radius: 4px;
            margin-bottom: 10px;
        }

        .scan-desc {
            font-size: 12px;
            line-height: 18px;
        }
    }

    &.group-box {

        .wechat-group {
            width: 349px;
            padding: 20px 37px 25px 20px;
            border-right: 1px dashed #606060;
            box-sizing: border-box;

            .group-title {
                display: flex;
                align-items: center;
                font-size: 14px;
                line-height: 20px;

                .group-icon {
                    font-size: 20px;
                    margin-right: 10px;
                }
            }

            .group-list {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                color: #ddd;

                .group-col {
                    .group-item {
                        display: flex;
                        margin-top: 10px;

                        .group-label {
                            width: 20px;
                            height: 20px;
                            border: 1px solid #707070;
                            box-sizing: border-box;
                            border-radius: 2px;
                            font-size: 12px;
                            color: #929292;
                            display: inline-block;
                            line-height: 18px;
                            text-align: center;
                            margin-right: 8px;
                        }
                    }
                }
            }

            .scan-area {
                display: flex;
                flex-direction: row;
                margin-top: 25px;

                img {
                    width: 90px;
                    height: 90px;
                }

                .scan-info {
                    margin-left: 10px;
                    margin-top: 20px;

                    .scan-tip {
                        margin-top: 8px;
                        font-size: 12px;
                        line-height: 20px;
                        color: #999;
                    }
                }
            }
        }

        .qq-group {
            width: 184px;
            padding-top: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .group-title {
                display: flex;
                align-items: center;
                font-size: 14px;
                line-height: 20px;

                .group-icon {
                    font-size: 20px;
                    margin-right: 10px;
                }
            }

            .qq-btn {
                width: 103px;
                height: 32px;
                margin-top: 20px;
                background-color: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.2);
                border-radius: 8px;
                color: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                text-decoration: none;
                font-size: 16px;

                &:hover {
                    background-color: #409EFF; // 主题蓝色
                    border-color: #409EFF; // 主题蓝色
                    color: #fff;
                }
            }

            .qq-tip {
                color: #999;
                margin-top: 10px;
                font-size: 12px;
                line-height: 20px;
            }
        }
    }
}
</style>
